import { companyPartnerIntegrationsService } from '@aslanpay/portal-common-lib';
import { useQuery } from '@tanstack/react-query';

export const fetchCompanyIntegrationsQuery = (companyId?: string, enabled = true) => ({
  queryKey: ['fetchCompanyIntegrations', companyId ?? ''],
  queryFn: () => companyPartnerIntegrationsService.list({ companyId: companyId ?? '' }),
  enabled: !!companyId && enabled,
});

const useFetchCompanyIntegrations = (companyId?: string, enabled = true) => {
  return useQuery(fetchCompanyIntegrationsQuery(companyId, enabled));
};

export default useFetchCompanyIntegrations;
